<template>
  <a-card :bordered="false">
    <a-form class="m-form" :form="form">
      <a-row type="flex" justify="center" align="top" :gutter="16">
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Tanggal Masuk">
            <a-date-picker
              class="w-full"
              :format="getDefaultDateFormat"
              v-decorator="['tglmasuk', {rules: [{required: true}]}]"
            />
          </a-form-item>
          <a-form-item label="Status Karyawan">
            <a-select v-decorator="['sts_karyawan', {rules: [{required: true}]}]">
              <a-select-option key="1" value="tetap">Tetap</a-select-option>
              <a-select-option key="2" value="kontrak">Kontrak</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Site">
            <a-select v-decorator="['site', {rules: [{required: true}]}]">
              <a-select-option key="1" value="surabaya">Surabaya</a-select-option>
              <a-select-option key="2" value="jakarta">Jakarta</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Kategori"><a-select showSearch v-decorator="['kategori']" allowClear>
              <a-select-option
                v-for="kategori in getMaster.kategori_pd"
                :key="kategori.kategori"
              >{{kategori.kategori}}</a-select-option>
            </a-select>
          </a-form-item>
          <!-- <a-form-item label="Golongan">
            <a-select v-decorator="['golongan', {rules: [{required: true}]}]">
              <a-select-option
                v-for="(golongan, index) in getMaster.golongan"
                :key="index"
                :value="golongan"
              >{{golongan}}</a-select-option>
            </a-select>
          </a-form-item> -->
          <a-form-item label="Career Path">
            <a-select
              v-decorator="['career_path', {rules: [{required: true}]}]"
              @change="changeCareer_path"
            >
              <a-select-option key="1" value="Struktural">Struktural</a-select-option>
              <a-select-option key="2" value="Fungsional">Fungsional</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Posisi">
            <a-select
              v-decorator="['posisi', {rules: [{required: true}]}]"
              v-if="!isfungsional"
            >
              <a-select-option
                v-for="(jabatan, index) in getMaster.posisi"
                :key="index"
                :value="jabatan.id_jabatan"
              >{{jabatan.nama_jabatan}} - Golongan {{jabatan.echelon}}</a-select-option>
            </a-select>
            <a-select
              v-decorator="['posisi', {rules: [{required: true}]}]"
              v-else
            >
              <a-select-option
                v-for="(jabatan, index) in getMaster.posisi"
                :key="index"
                :value="jabatan.id_jabatan"
              >{{jabatan.nama_jabatan}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Grade" v-if="isfungsional">
            <a-select show-search
              allowClear :filterOption="handleFilterJabatan"
              v-decorator="['grade', { rules: [{required: true}]}]"
            >
              <a-select-option
                v-for="pangkat in getMaster.pangkat"
                :key="pangkat.id_pangkat"
                :value="pangkat.id_pangkat"
              >{{pangkat.nama_pangkat}} - Golongan {{pangkat.echelon}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Jabatan">
            <a-auto-complete
              :dataSource="getMaster.jabatan"
              placeholder="input here"
              v-decorator="['jabatan', {rules: [{required: true}]}]"
              :filterOption="handleFilterJabatan"
            />
          </a-form-item>
          <a-form-item label="Departemen">
            <a-select allowClear v-decorator="['id_dept']">
              <a-select-option
                v-for="departemen in getMaster.departemen"
                :key="departemen.id_dept"
              >{{departemen.nama_dept}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Divisi">
            <a-select allowClear v-decorator="['divisi']">
              <a-select-option
                v-for="divisi in getMaster.divisi"
                :key="divisi"
                :value="divisi"
              >{{divisi}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Atasan Langsung">
            <a-select allowClear showSearch v-decorator="['atasan']">
              <a-select-option
                v-for="atasan in getMaster.list_atasan"
                :key="atasan"
                :value="atasan"
              >{{atasan}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Work Hours">
              <a-select
                allowClear
                v-decorator="['work_hours', {rules: [{required: true}]}]"
              >
                <a-select-option :key="0" :value="'Fixed'">Fixed</a-select-option>
                <a-select-option :key="1" :value="'Shift'">Shift</a-select-option>
              </a-select>
            </a-form-item>
          <a-form-item label="No Rekening">
            <a-input autocomplete="off" v-decorator="['no_rek']" />
          </a-form-item>
          <a-form-item label="Bank">
            <a-select allowClear v-decorator="['bank']">
              <a-select-option
                v-for="bank in getBank"
                :key="bank.code"
                :value="bank.name"
              >{{bank.name}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "employee",
  data() {
    return {
      isfungsional:true,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("Fetch_Bank");
  },
  computed: {
    ...mapGetters(["getMaster", "getBank", "getDefaultDateFormat"])
  },
  methods: {
    handleFilterJabatan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let posisiNm = _.filter(this.getMaster.posisi,filt =>
            filt.id_jabatan==values.posisi
        );
        values.nama_jabatan = posisiNm[0].nama_jabatan;
        Event.$emit("createKaryawan", values);
      });
    },
    changeCareer_path(e){
      this.isfungsional = e=="Struktural" ? false : true;
    }
  }
};
</script>

<style>
</style>